module.exports = __webpack_public_path__ + "img/9-small.c49a74b9.png";